import { Modal, Button, Table, Tag } from "antd"
import { formatNumber } from "../../../utils";
import { useMemo } from "react"; // นำเข้า useMemo
import { tagsBageStatus } from "../../../helpers/tagsBage";
import { getIcon } from "../../../helpers/getIcon";

export const DetailsModel = ({ isModalOpen, handleCancel, t, detailsData, titleModel }) => {
   
    const safeData = Array.isArray(detailsData) ? detailsData : [];

    const columns = useMemo(() => {
        const config = [
            {
                title: t('#'), // แนะนำให้ครอบ t() เพื่อรองรับภาษา
                dataIndex: 'feeplatform',
                key: 'feeplatform',
                render: (text, record, index) => (index + 1), // แสดงลำดับที่เริ่มต้นจาก 1
            },
            {
                title: t('Description'), // แนะนำให้ครอบ t() เพื่อรองรับภาษา
                dataIndex: 'name',
                key: 'name',
                render: (text) => (text === null || text === undefined) ? '-' : t(text),
            },
            {
                title: t('transactions'),
                dataIndex: 'totalTransactions',
                key: 'totalTransactions',
                render: (text) => (text === null || text === undefined) ? '-' : formatNumber(text),
            },
            {
                title: t('fee'),
                dataIndex: 'fee',
                key: 'fee',
                render: (text) => (text === null || text === undefined) ? '-' : formatNumber(text),
            },
            
            {
                title: t('Status'),
                dataIndex: 'status',
                key: 'status',
                render: (text) => (<Tag icon={getIcon(text)} color={tagsBageStatus(text)}>{t(text)}</Tag>),

            },
        ];
        // กรองเฉพาะคอลัมน์ที่มีข้อมูลจริงใน safeData
        return config.filter(col => safeData.some(item => item[col.dataIndex] !== null && item[col.dataIndex] !== undefined && item[col.dataIndex] !== ""));
    }, [safeData, isModalOpen, t]);

    const hasData = safeData.length > 0;

    
    return (
        <Modal
            title={`${t("Details")}: ${t(titleModel)}`}
            open={isModalOpen}
            onCancel={handleCancel}
            width={800}
            style={{ top: 20 }}
            maskClosable={false}
            destroyOnClose={true} 
            footer={[
                <Button key="back" onClick={handleCancel}>
                    {t("Close")}
                </Button>
            ]}
        >
            <div className="body table-responsive mt-3">
                {hasData ? (
                    <Table
                        className="col-lg-12"
                        rowKey={(record) => record.id || record.name} // ใช้ id หรือ name เป็น key
                        dataSource={safeData}
                        pagination={false}
                        columns={columns}
                        scroll={{ x: "max-content" }}
                    />
                ) : (
                    <div style={{ textAlign: 'center', padding: '20px' }}>{t("No Data")}</div>
                )}
            </div>
        </Modal>
    );
};